import { DistanceType } from '../enums/DistanceType';
import { RecipeType } from '../enums/RecipeType';

//rule: alphabetic order
const recipeStringResources = {
    BifocalRecipeTypeDescription: 'Muiltifocal',
    SingleVisionRecipeTypeDescription: 'Monofocal',
    ToNear: 'Para Perto',
    ToFar: 'Para Longe',
}

const recipeTypeOptions = [
    { Type: RecipeType.Bifocal, Description: recipeStringResources.BifocalRecipeTypeDescription },
    { Type: RecipeType.SingleVision, Description: recipeStringResources.SingleVisionRecipeTypeDescription },
];

const distanceTypeOptions = [
  { Type: DistanceType.Near, Description: recipeStringResources.ToNear },
  { Type: DistanceType.Far, Description: recipeStringResources.ToFar },
];

//rule: alphabetic order
export const recipeResources = {
    ...recipeStringResources,
    RecipeTypeOptions: recipeTypeOptions,
    DistanceTypeOptions: distanceTypeOptions,
};